import clsx from 'clsx';
import React from 'react';
import { polymorphicFactory } from '../../factory/factory.utils.mjs';
import { Typography } from '../../Foundations/Typography/Typography.mjs';
import { Box } from '../../Other/Box/Box.mjs';
import classes from './ActionIndicator.module.css.mjs';
import { actionIndicatorIconPath } from './ActionIndicator.utils.mjs';

const ActionIndicator = polymorphicFactory((props, ref) => {
  const { type, label, showLabel = true, className, icon, iconPosition = "left", ...rest } = props;
  const classNames = clsx("kohler-action-indicator-root", className, classes.root);
  if (type)
    console.warn(
      "Property `type` will be deprecated soon. Please use `icon` instead. Example here: https://bold.kohler.com/components/buttons/action-indicator/code#basic-action-indicator-icon"
    );
  const TypeIcon = type && actionIndicatorIconPath[type];
  const Icon = icon;
  const renderLeftIcon = iconPosition === "left";
  const renderRightIcon = iconPosition === "right";
  return /* @__PURE__ */ React.createElement(Box, { component: "button", className: classNames, ref, ...rest }, Icon && renderLeftIcon && /* @__PURE__ */ React.createElement(Icon, { withBoundingBox: false, size: "medium" }), !Icon && TypeIcon && TypeIcon.leftIcon && /* @__PURE__ */ React.createElement(TypeIcon.leftIcon, { withBoundingBox: false, size: "medium" }), showLabel && /* @__PURE__ */ React.createElement(Typography, { component: "span", size: "label-regular-m", className: clsx(classes.text, type === "PDF link" && classes.underlineText) }, label ? label : type), Icon && renderRightIcon && /* @__PURE__ */ React.createElement(Icon, { withBoundingBox: false, size: "medium" }), !Icon && TypeIcon && TypeIcon.rightIcon && /* @__PURE__ */ React.createElement(TypeIcon.rightIcon, { withBoundingBox: false, size: "medium" }));
});

export { ActionIndicator };
